export default {
  '请求': {
    '加载中': '加载中',
    '请求失败': '请求失败',
    '登录已过期': '登录已过期',
    '网络连接失败': '网络连接失败',
    '请重新登录': '请重新登录',
    '没有权限访问': '没有权限访问',
    '请求的资源不存在': '请求的资源不存在',
    '服务器错误': '服务器错误',
    '网络错误': '网络错误',
    '刷新成功': '刷新成功',
    '获取中': '获取中......',
    '账号下线': '账号下线',
    '功能已禁用': '功能已禁用',
  },
  '导航': {
    '首页': '首页',
    '选妃': '选妃',
    '认证': '认证',
    '影院': '影院',
    '个人': '个人',
  },
  '首页': {
    '注册': '注册',
    '影片': '影片',
    '女团': '女团',
    '热门城市': '热门城市：',
    '经理预订': '经理预订',
    '看更多': '看更多',
    '身份验证': '身份验证',
    '身高': '身高',
    '胸围': '胸围',
    '服务城市': '服务城市：',
  },
  '女团': {
    '女团': '女团',
    '选妃': '选妃',
    '身份验证': '身份验证',
    '身高': '身高',
    '胸围': '胸围',
    '服务城市': '服务城市:',
    '注册': '注册',
    '请联系顾问或接待员': '请联系顾问或接待员',
  },
  '登录': {
    '登录会员视窗': '登录会员视窗',
    '请输入用户名': '请输入用户名',
    '请输入密码': '请输入密码',
    '登录': '登录',
    '没有账号马上注册': '没有账号？ 马上注册',
    '登录成功': '登录成功',
    '登录注册': '登录/注册',
    '登录可享受更多服务': '登录可享受更多服务！',
  },
  '注册': {
    '注册': '注册',
    '登录': '登录',
    '请输入用户名': '请输入用户名',
    '用户名规则': '6-20位英文字母、数字及其组合',
    '请输入密码': '请输入密码',
    '密码规则': '6-16位字符和数字组合',
    '请输入验证码': '请输入验证码',
    '验证码规则': '请输入4位英数字验证码',
    '请输入邀请码': '请输入邀请码',
    '邀请码规则': '请输入代理邀请码',
    '同意协议': '我已满18岁，同意《注册条件》',
    '立即注册': '立即注册',
    '注册中': '注册中...',
    '已有账号马上登录': '已有账号？马上登录',
    '注册成功': '注册成功！',
    '注册失败': '注册失败：',
    '验证码错误': '验证码错误',
    '请同意注册条款': '请同意注册条款',
    '用户名已存在': '用户名已存在',
    '邀请码无效': '邀请码无效',
  },
  '抢单': {
    '今日收益': '今日收益',
    '余额': '余额',
    '订单': '订单',
    '开始抢单': '开始抢单',
    '当前等级': '当前等级：',
    '提现': '提现',
    '在线客服': '在线客服',
    '充值': '充值',
    '幸运任务': '幸运任务',
    '幸运订单': '幸运订单',
    '幸运订单提示': '恭喜！这是一笔高佣金幸运订单',
    '恭喜获得幸运订单': '恭喜获得幸运订单！',
    '提交订单': '提交订单',
    '未完成订单提示': '您有未完成的订单，请先完成支付后再获取新订单',
    '正在获取订单': '正在获取订单...',
    '抢单时间': '抢单时间：',
    '订单号': '订单号',
    '订单总额': '订单总额',
    '佣金': '佣金',
    '商品单价': '商品单价',
    '预计收入': '预计收入',
    '确认支付': '确认支付',
    '确认付款': '确认付款',
    '支付处理中': '支付处理中...',
    '取消': '取消',
    '去查看': '去查看',
    '暂无可用订单': '暂无可用订单',
    '正在加载用户信息': '正在加载用户信息，请稍候...',
    '今日抢单已达上限': '今日抢单次数已达上限',
    '余额不足无法获取订单': '余额不足，无法获取订单',
    '获取订单失败': '获取订单失败',
    '支付成功': '支付成功',
    '支付失败': '支付失败',
    '支付失败请重试': '支付失败，请重试',
    '请完成任务单后进入': '请完成任务单后进入',
    '请设置收款卡': '请设置收款卡',,
    '当前余额': '当前余额',
    '还需缴纳': '还需缴纳',
  },
  '我的': {
    '我的页面': '我的页面',
    '钻石': '钻石',
    '信誉分': '信誉分',
    '开通专属会员': '开通专属会员',
    '开启一次日期不限': '开启一次，日期不限',
    '提现': '提现',
    '历史订单': '历史订单',
    '充值记录': '充值记录',
    '提现记录': '提现记录',
    '添加钱包地址': '添加钱包地址',
    '邀请码': '邀请码：',
    '余额': '余额',
    '退出登陆': '退出登陆',
  },
  '会员': {
    '会员等级': '会员等级：',
    '普通等级': '普通等级',
    '当前等级': '当前等级',
    '立即开通': '立即开通',
    '免费说明': '(免费观看视频) (免费配对)',
    '所需投资': '所需投资',
    '佣金': '佣金',
    '订单': '订单',
    '加入': '加入>>',
  },
  '充值': {
    '充值': '充值',
    '当前余额': '当前余额',
    '余额': '余额：',
    '个': '个',
    '充值金额': '充值金额',
    '请输入充值金额': '请输入充值金额',
    '快速选择金额': '快速选择金额',
    '确认': '确认',
    '提示': '提示',
    '金额错误': '金额错误',
    '立即充值': '立即充值',
    '提交成功': '提交成功，请等待审核',
  },
  '提现': {
    '提现': '提现',
    '兑换积分': '兑换积分',
    '最大提款金额': '最大提款金额',
    '资金密码': '资金密码',
    '余额': '余额：',
    '个': '个',
    '钱包地址': '钱包地址：',
    '请选择提款地址': '请选择提款地址',
    '暂无绑定地址': '暂无绑定地址，请先绑定',
    '提交': '提交',
    '通知': '通知：',
    '单笔最大提现': '1、单笔最大提现金金额:',
    '单笔最低提现': '2、单笔提现最低限额：',
    '检查姓名账号': '3、请检查您的姓名和提款账号',
    '注意提款费用': '4、注意提款费用',
    '请填写正确的金额': '请填写正确的金额',
    '当前余额': '当前余额',
    '提现金额': '提现金额',
    '请输入提现数量': '请输入提现数量',
    '立即提现': '立即提现',
    '交易密码': '交易密码',
    '请输入交易密码': '请输入交易密码',
    '请先设置提现密码': '请先设置提现密码',
  },
  '绑卡': {
    '添加钱包地址': '添加钱包地址',
    '钱包地址信息': '钱包地址信息',
    '请输入支付卡信息': '请输入您的钱包地址信息',
    '加密货币类型': '加密货币类型',
    '请选择加密货币类型': '请选择加密货币类型',
    '钱包地址': '钱包地址',
    '请输入钱包地址': '请输入钱包地址',
    '绑卡说明': '亲爱的用户，为了确保您的资金安全，请链接您的真实姓名并设置取款密码。如果您的姓名与账户名称不匹配，您将无法提取资金。',
    '确定绑卡': '确定绑卡',
    '绑卡提示': '提示:请绑定大型商业银行,如需修改,请您联系在线客服',
    '请先设置姓名': '请设置姓名后再绑定钱包地址！',
    '已绑定不可修改': '已绑定提现地址，如需修改请联系客服',
  },
  '订单历史': {
    '订单历史': '订单历史',
    '数据为空': '数据为空',
    '订单号': '订单号：',
    '已完成': '已完成',
    '处理中': '处理中',
    '完成订单': '完成订单',
    '订单金额': '订单金额：',
    '佣金': '佣金：',
    '创建时间': '创建时间：',
    '上一页': '上一页',
    '下一页': '下一页',
    '获取失败': '获取订单历史失败',
    '获取失败重试': '获取订单历史失败，请重试',
    '未知': '未知',
    '完成成功': '订单完成成功！',
    '完成失败': '订单完成失败：',
    '完成失败重试': '订单完成失败，请重试',
    '请输入支付密码': '请输入支付密码',
    '请先设置支付密码': '请先设置支付密码',
  },
  '入金记录': {
    '标题': '充值记录',
    '数据为空': '数据为空',
    '认证结果': '认证结果',
    '下单积分': '下单积分：',
    '下单时间': '下单时间：',
    '结算时间': '结算时间：',
    '待审核': '待审核',
    '已通过': '已通过',
    '已拒绝': '已拒绝',
    '暂无数据': '暂无数据',
  },
  '提现记录': {
    '标题': '提现记录',
    '数据为空': '数据为空',
    '待审核': '待审核',
    '审核成功': '审核成功',
    '审核退回': '审核退回',
    '未知状态': '未知状态',
    '金额': '金额：',
    '说明': '说明：',
    '提交时间': '提交时间：',
    '审核时间': '审核时间：',
    '已通过': '已通过',
    '已拒绝': '已拒绝',
    '暂无数据': '暂无数据',
  },
  '资料': {
    '基本信息': '基本信息',
    '头像': '头像',
    '姓名': '姓名',
    '未设置': '未设置',
    '性别': '性别',
    '男': '男',
    '女': '女',
    '未知': '未知',
    '设定': '设定',
    '账号信息': '账号信息',
    '更改登录密码': '更改登录密码',
    '设定支付密码': '设定支付密码',
    '退出登录': '退出登录',
    '设置': '设置',
    '登录密码': '登录密码',
    '资金密码': '资金密码',
    '提现密码已设置': '提现密码已设置，需要修改请联系客服',
    '已设置': '已设置',
    '修改真实姓名': '修改真实姓名',
    '请输入真实姓名': '请输入真实姓名',
    '真实姓名说明': '为了您账户安全,真实姓名需要与钱包信息一致',
    '提交': '提交',
    '请勿重复设置': '请勿重复设置！',
    '修改登录密码': '修改登录密码',
    '设置资金密码': '设置资金密码',
    '保存': '保存',
    '旧密码': '旧密码',
    '请输入旧密码': '请输入您的旧密码',
    '新密码': '新密码',
    '请输入新密码': '请输入您的新密码',
    '确认密码': '确认密码',
    '请再次输入新密码': '请再次输入您的新密码',
    '请填写完整': '请填写完整！',
    '两次密码不一致': '两次密码输入不一致',
    '性别修改': '性别修改',
    '个人报表': '个人报表',
    '任务金额积分': '任务金额(积分)',
    '盈利公式': '盈利计算公式 : 中奖金额 - 任务金额',
    '任务金额': '任务金额',
    '充值金额': '充值金额',
    '金额': '金额',
    '中奖金额': '中奖金额',
    '个人情报': '个人情报',
    '身高': '身高:',
    '胸围': '胸围：',
    '收费区间': '收费区间：',
    '系统公告': '系统公告',
  },
  '客服': {
    '联系客服': '联系客服',
    '在线客服': '在线客服',
    '暂无客服': '暂无客服',
    '联系': '联系',
    '服务时间': '全天7 * 24小时竭诚为您服务',
  },
  '影院': {
    '影院': '影院',
    '全部': '全部',
    '最高分': '最高分',
    '播放': '播放 :',
    '次播放': '次播放',
    '热门推荐': '热门推荐',
    '播放次数': '播放:',
    '请充值后观看': '请充值后观看视频',
  },
  '语言切换器': {
    '切换语言': '切换语言',
    '语言': '语言',
  },
}